import request from '@/config/axios'

// AI 智能体 VO
export interface AiAgentVO {
  id: number
  agentCode: string
  agentName: string
  employeeId: number
  modelId?: number
  promptId?: number
  skillIds?: number[]
  description?: string
  status: number
  remark?: string
  createTime?: Date
}

// AI 智能体 API
export const AgentApi = {
  // 获得智能体分页
  getAgentPage: async (params: any) => {
    return await request.get({ url: '/ai/agent/page', params })
  },

  // 获得智能体详情
  getAgent: async (id: number) => {
    return await request.get({ url: '/ai/agent/get?id=' + id })
  },

  // 创建智能体
  createAgent: async (data: AiAgentVO) => {
    return await request.post({ url: '/ai/agent/create', data })
  },

  // 更新智能体
  updateAgent: async (data: AiAgentVO) => {
    return await request.put({ url: '/ai/agent/update', data })
  },

  // 删除智能体
  deleteAgent: async (id: number) => {
    return await request.delete({ url: '/ai/agent/delete?id=' + id })
  },

  // 获得智能体下拉列表
  getAgentSimpleList: async () => {
    return await request.get({ url: '/ai/agent/simple-list' })
  }
}
